// src/layouts/admin/AdminLayout.js
import React from 'react';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const AdminLayout = () => (
  <div className="wrapper">
    <Header />
    <Menu />
    <div className="content-wrapper">
      <Outlet /> {/* This renders nested routes */}
    </div>
    <Footer />
  </div>
);

export default AdminLayout;
